import styles from './ProductTileModule.scss';

import cx from 'classnames';
import { ReferencedEntry } from 'contentful';
import React from 'react';

import { ProductTileAssembly } from 'src/api/contentful/contentTypes.cloverdotcom';
import { isEntry } from 'src/utils/EntryUtil';

import { Text } from '../Contentful/Text';
import { Tile } from './Tile/Tile';

// Contentful JSON Editor can return either Array or Object
export function getStyle(styles: unknown, index: number): React.CSSProperties | undefined {
  if (Array.isArray(styles)) return index < styles.length ? styles[index] : undefined;

  if (styles && styles instanceof Object) return styles;

  return;
}

export interface IProductTileModule extends React.AllHTMLAttributes<HTMLElement> {
  entry?: ReferencedEntry<ProductTileAssembly>;
}

const ProductTileModule: React.FC<IProductTileModule> = ({
  className,
  entry,
  ...props
}) => {
  if (!isEntry(entry)) return null;
  const { items = [], styles: tileStyles } = entry.fields;

  const isSingle = items.length === 1;

  return (
    <section
      className={cx(className, styles.productTileWrapper)}
      {...props}
    >
      <div
        className={cx(styles.productTileModule, {
          [styles.productTileModuleSingle]: isSingle,
        })}
      >
        <Text tagName="h2" entry={entry} field="title" className={styles.productTileModuleTitle} />
        {items.length > 0 && (
          <div className={styles.productTileItems}>
            {items.map((item, index) => (
              <Tile
                key={item.sys.id}
                entry={item}
                single={isSingle}
                style={getStyle(tileStyles, index)}
              />
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export { ProductTileModule };
